'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './mobile-icon-carousel.component';
import dynamic from 'next/dynamic';

const DynamicMobileIconCarouselComponent: ComponentType<Props> = dynamic(
  () => import('./mobile-icon-carousel.component')
);

export default DynamicMobileIconCarouselComponent;

export function calculateMobileIconCarouselPlaceholderConfig(): PlaceholderConfig {
  return {
    heightSinceWidth: [{ sinceWidth: 0, height: 88 }]
  };
}
